/**
 * @generated SignedSource<<5ba5a3722dc34d1f47753c5f17e7ea4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselRequestMoreImages_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpRespHeroCarouselRequestMoreImages_user";
};
export type PdpRespHeroCarouselRequestMoreImages_user$key = {
  readonly " $data"?: PdpRespHeroCarouselRequestMoreImages_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarouselRequestMoreImages_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1312d899977bc0e275bac12dd2af63cc";

export default node;
